import React from "react";
import Show from "../../../../../utils/show.component";

export const RefinancePopupButton = ({
  IsRefinanceAllowed,
  callAuthRefinanceRedirect,
  AccountHash,
}) => {
  return (
    <Show condition={IsRefinanceAllowed}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={() => {
            callAuthRefinanceRedirect(AccountHash);
          }}
        >
          Apply to Refinance Loan
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/refinance-popup-button.component.js